import React from 'react';
import NavBar from '../components/NavBar/NavBar.component';
import ErrorBoundary from 'src/ErrorBoundary';

const withNavBar = (Component) => (props) => {
  return (
    <ErrorBoundary>
      <NavBar cookies={props.cookies.getAll()} />
      <Component cookies={props.cookies.getAll()} />
    </ErrorBoundary>
  );
};

export default withNavBar;
